import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';

import classNames from 'classnames';

import { FETCH_STATUS, URL_TYPES } from '../Constants';
import english from '../Images/Icons/icon_english.svg';
import swedish from '../Images/Icons/icon_swedish.svg';
import information from '../Images/Icons/icon_information_white.svg';

const TopMenu = () => {
  const [showLanguageMenu, setShowLanguageMenu] = useState(true);
  const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false);
  const [aboutDropdownOpen, setAboutDropdownOpen] = useState(false);
  const [languageIcon, setLanguageIcon] = useState();

  const dispatch = useDispatch();
  const {
    language,
    text: { topMenu: pageText },
  } = useSelector(state => state.Language);
  const municipality = useSelector(state => state.MunicipalityReducer);
  const { location: { pathname } } = useSelector(state => state.router);

  const menuRef = useRef(null);

  useEffect(() => {
    const onClickOutsideMenu = (e) => {
      if (!menuRef.current.contains(e.target)) {
        setLanguageDropdownOpen(false);
        setAboutDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', onClickOutsideMenu);

    return () => {
      document.removeEventListener('mousedown', onClickOutsideMenu);
    };
  }, []);

  useEffect(() => {
    if (language === 'en') {
      setLanguageIcon(english);
    } else {
      setLanguageIcon(swedish);
    }
  }, [language]);

  useEffect(() => {
    if (municipality.status === FETCH_STATUS.SUCCEEDED && municipality.languages.length < 2) {
      setShowLanguageMenu(false);
    }
  }, [municipality.status]);

  const onClickLanguage = (lang) => {
    dispatch(push(pathname.replace(`/${language}/`, `/${lang}/`)));
    setLanguageDropdownOpen(false);
  };

  const onClickAboutMunicipality = () => {
    dispatch(push(`/${language}/${municipality.name}/${URL_TYPES.ABOUT_MUNICIPALITY}`));
  };

  const onClickAboutService = () => {
    dispatch(push(`/${language}/${URL_TYPES.ABOUT_SERVICE}`));
  };

  const renderLanguageDropdown = () =>
    (
      <div className="dropdown">
        <div className="dropdown__arrow dropdown__arrow--language" />
        <div className="dropdown__button-container">
          <div
            className={classNames(language === 'sv' ? 'checked' : 'unchecked', 'dropdown__button')}
            role="menuitem"
            tabIndex="0"
            value="sv"
            onClick={() => { onClickLanguage('sv'); }}
            onKeyPress={() => { onClickLanguage('sv'); }}
          >
            {pageText.swedish}
          </div>
          <div
            className={classNames(language === 'en' ? 'checked' : 'unchecked', 'dropdown__button')}
            role="menuitem"
            tabIndex="0"
            value="en"
            onClick={() => { onClickLanguage('en'); }}
            onKeyPress={() => { onClickLanguage('en'); }}
          >
            {pageText.english}
          </div>
        </div>
      </div>
    );

  const renderAboutDropDown = () =>
    (
      <div className="dropdown">
        <div className="dropdown__arrow dropdown__arrow--information" />
        <div className="dropdown__button-container">
          <div
            className={classNames({ 'dropdown__button--hidden': !municipality.name }, 'dropdown__button')}
            role="menuitem"
            tabIndex="0"
            onClick={onClickAboutMunicipality}
            onKeyPress={onClickAboutMunicipality}
          >
            {pageText.aboutMunicipality}
          </div>
          <div
            className="dropdown__button"
            role="menuitem"
            tabIndex="0"
            onClick={onClickAboutService}
            onKeyPress={onClickAboutService}
          >
            {pageText.aboutService}
          </div>
        </div>
      </div>
    );

  return (
    <div className="top-menu" ref={menuRef}>
      <ul className="top-menu__navbar">
        <li
          className={classNames({ 'is-hidden': !municipality.name }, 'hide-for-small-only', 'top-menu__button')}
          role="menuitem"
          tabIndex="0"
          onClick={onClickAboutMunicipality}
          onKeyPress={onClickAboutMunicipality}
        >
          <div className="menu-heading-label">{pageText.aboutMunicipality}</div>
        </li>
        <li
          className="hide-for-small-only top-menu__button"
          role="menuitem"
          tabIndex="0"
          onClick={onClickAboutService}
          onKeyPress={onClickAboutService}
        >
          <div className="top-menu__button-label">{pageText.aboutService}</div>
        </li>
        <li
          className="show-for-small-only top-menu__button"
          tabIndex="0"
          onClick={() => { setAboutDropdownOpen(true); setLanguageDropdownOpen(false); }}
          onKeyPress={() => { setAboutDropdownOpen(true); setLanguageDropdownOpen(false); }}
          role="menuitem"
        >
          <img src={information} alt="missingdata" />
        </li>
        <li
          onClick={() => { setLanguageDropdownOpen(true); setAboutDropdownOpen(false); }}
          onKeyPress={() => { setLanguageDropdownOpen(true); setAboutDropdownOpen(false); }}
          role="menuitem"
          className={classNames({ 'is-hidden': !showLanguageMenu }, { 'top-menu__button--selected': languageDropdownOpen }, 'top-menu__button')}
          tabIndex="0"
        >
          <div className="top-menu__button-label">{pageText.language}</div>
          <div className="top-menu__button-icon"><img src={languageIcon} alt={pageText.language} /></div>
        </li>
      </ul>
      {aboutDropdownOpen && renderAboutDropDown()}
      {languageDropdownOpen && renderLanguageDropdown()}
    </div>
  );
};

export default TopMenu;



// WEBPACK FOOTER //
// ./src/Components/TopMenu.js